export default {
      id: "ic_other_bets_change-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_other_bets_change-usage",
      toString: function () {
        return this.url;
      }
    }